exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes bomb {\n  from {\n    top: -100px; }\n  to {\n    top: 350px; } }\n\n.bomb {\n  position: absolute;\n  z-index: 1;\n  animation-name: bomb;\n  height: 100px; }\n\n.bomb.left {\n  left: 90px; }\n\n.bomb.right {\n  right: 90px; }\n", ""]);

